__turbopack_context__.v({
  "button": "s9-Bwq_button",
  "button__icon": "s9-Bwq_button__icon",
});
